<template>
  <div class="archive-entry-feed" data-testid="archive-entry-feed">
    <div
      v-for="(group, groupIndex) in groups"
      :key="group.key"
      class="archive-entry-feed__group"
      :data-testid="`archive-month-${group.key}`"
    >
      <button
        v-if="groupIndex > 0"
        type="button"
        class="archive-entry-feed__group-toggle"
        :data-testid="`archive-month-toggle-${group.key}`"
        @click="toggleGroup(group.key)"
      >
        <i
          class="pi pi-chevron-down archive-entry-feed__chevron"
          :class="{ 'archive-entry-feed__chevron--collapsed': !isExpanded(group.key) }"
          aria-hidden="true"
        />
        <span>{{ group.label }}</span>
      </button>
      <h3
        v-else
        class="archive-entry-feed__group-title"
      >
        {{ group.label }}
      </h3>

      <div
        v-if="groupIndex === 0 || isExpanded(group.key)"
        class="archive-entry-feed__card"
      >
        <ArchiveEntryRow
          v-for="entry in group.entries"
          :key="entry.id"
          :entry="entry"
          :user-lookup="userLookup"
          :milestone-lookup="milestoneLookup"
          @select="$emit('select-entry', entry)"
        />
      </div>

      <button
        v-else
        type="button"
        class="archive-entry-feed__expand-link"
        :data-testid="`archive-month-expand-${group.key}`"
        @click="toggleGroup(group.key)"
      >
        {{ $t('UserProjects.archive.showEntries', { count: group.entries.length }) }}
      </button>
    </div>
  </div>
</template>

<script>
import ArchiveEntryRow from '@/components/CustomerApp/UserProjects/ArchiveEntryRow.vue';

export default {
  name: 'ArchiveEntryFeed',
  components: {
    ArchiveEntryRow,
  },
  props: {
    groups: {
      type: Array,
      default: () => [],
    },
    userLookup: {
      type: Object,
      default: () => ({}),
    },
    milestoneLookup: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['select-entry'],
  data() {
    return {
      expandedGroups: {},
    };
  },
  watch: {
    groups: {
      immediate: true,
      handler(nextGroups) {
        const expanded = { ...(this.expandedGroups || {}) };
        (nextGroups || []).forEach((group, index) => {
          if (index === 0) {
            expanded[group.key] = true;
          }
        });
        this.expandedGroups = expanded;
      },
    },
  },
  methods: {
    isExpanded(groupKey) {
      return Boolean(this.expandedGroups[groupKey]);
    },
    toggleGroup(groupKey) {
      this.expandedGroups = {
        ...this.expandedGroups,
        [groupKey]: !this.isExpanded(groupKey),
      };
    },
  },
};
</script>

<style scoped>
.archive-entry-feed {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.archive-entry-feed__group-title,
.archive-entry-feed__group-toggle {
  margin: 0 0 0.75rem;
  font-size: 14px;
  font-weight: 600;
  color: var(--color-dark);
}

.archive-entry-feed__group-toggle {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
}

.archive-entry-feed__group-toggle:hover {
  opacity: 0.75;
}

.archive-entry-feed__chevron {
  font-size: 0.875rem;
  transition: transform 0.15s ease;
}

.archive-entry-feed__chevron--collapsed {
  transform: rotate(-90deg);
}

.archive-entry-feed__card {
  background: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 14px;
  overflow: hidden;
}

.archive-entry-feed__card :deep(.archive-entry-row:not(:last-child)) {
  border-bottom: 1px solid #f2f2f2;
}

.archive-entry-feed__expand-link {
  padding: 0;
  border: none;
  background: transparent;
  color: var(--color-orange);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
}

.archive-entry-feed__expand-link:hover {
  text-decoration: underline;
}
</style>
